module.exports = __webpack_public_path__ + "static/img/ent-detail-41.95e457b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-41.jpg
// module id = JFe9
// module chunks = 52